import DashboardNavbar from "../../../components/Navbars/DashboardNavbar";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import Grid from "@mui/material/Grid";
import Footer from "../../../components/Footer";
import useSaleDetails from "./useSaleDetails";
import DashboardLayout from "../../../components/LayoutContainers/DashboardLayout";
import bgImage from "assets/images/bg_doctor.jpg";
import {COLOR_SECONDARY} from "../../../config";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import React from "react";
import PersonAddIcon from '@mui/icons-material/PersonAddOutlined';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacyOutlined';
import AccessibilityIcon from '@mui/icons-material/Accessibility';

const SaleDetails = () => {

    const {id, sale, isLoading, renderSaleItems, renderStatusChip} = useSaleDetails();

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={2}>
                {
                    isLoading ?
                        <MDBox mt={2} mx={2} p={10} display="flex" justifyContent="center"
                               alignItems="center">
                            <CircularProgress color="secondary" style={{overflow: 'hidden'}}/>
                        </MDBox> :
                        <>
                            <Grid container justifyContent="center">
                                <Grid item xs={12} lg={12}>
                                    <Card>
                                        <MDBox p={4}>
                                            <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start'}}>
                                                <MDBox>
                                                    <MDTypography variant="h4">ID de la venta: #ORD-{sale.id}</MDTypography>
                                                    <MDTypography variant="subtitle2">{sale.created_at}</MDTypography>
                                                </MDBox>
                                                <MDBox ml={1}>
                                                    {
                                                        renderStatusChip(sale.status)
                                                    }
                                                </MDBox>
                                            </MDBox>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} lg={9}>
                                                    <MDBox mt={2} sx={{padding: 2, borderStyle: 'solid', borderWidth: 1, borderColor: '#e2e2e2', borderRadius: 2}}>
                                                        <MDTypography variant="h6">Productos</MDTypography>
                                                        <MDTypography variant="subtitle2">Información sobre los productos comprados</MDTypography>
                                                        {
                                                            renderSaleItems()
                                                        }
                                                    </MDBox>
                                                    <MDBox mt={2} sx={{padding: 2, borderStyle: 'solid', borderWidth: 1, borderColor: '#e2e2e2', borderRadius: 2}}>
                                                        <MDTypography variant="h6">Detalles de Pago</MDTypography>
                                                        <MDTypography variant="subtitle2">Información sobre los pagos y comisiones</MDTypography>
                                                        <Grid container sx={{marginTop: 2}}>
                                                            <Grid item xs={12} lg={6}>
                                                                <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 16, marginTop: 1}}>Comisión:</MDTypography>
                                                            </Grid>
                                                            <Grid item xs={12} lg={6}>
                                                                <MDTypography variant="body2" fontWeight="medium" sx={{fontSize: 16, textAlign: 'right', marginTop: 1}}>${sale.doctor_fee} MXN</MDTypography>
                                                            </Grid>
                                                        </Grid>
                                                    </MDBox>
                                                </Grid>
                                                <Grid item xs={12} lg={3}>
                                                    <MDBox mt={2} sx={{padding: 2, borderStyle: 'solid', borderWidth: 1, borderColor: '#e2e2e2', borderRadius: 2}}>
                                                        <MDTypography variant="h6" sx={{marginBottom: 2}}>Datos Generales</MDTypography>
                                                        <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                                            <PersonAddIcon></PersonAddIcon>
                                                            <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>{sale.doctor.name}</MDTypography>
                                                        </MDBox>
                                                        <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 1}}>
                                                            <AccessibilityIcon></AccessibilityIcon>
                                                            <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>{sale.patient.name} {sale.patient.last_name} {sale.patient.mother_last_name}</MDTypography>
                                                        </MDBox>
                                                        <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 1}}>
                                                            <LocalPharmacyIcon></LocalPharmacyIcon>
                                                            <MDTypography variant="body2" sx={{marginLeft: 1, fontSize: 16}}>{sale.location.display_name}</MDTypography>
                                                        </MDBox>
                                                    </MDBox>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    </Card>
                                </Grid>
                            </Grid>
                        </>
                }
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default SaleDetails;
